var _style, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNegativeIsotype(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "10 8 172.6 127",
    style: {
      enableBackground: "new 0 0 182.6 135"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#ED1652;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M89.5,134.5c-2.3,0-4.6-0.9-6.3-2.6l-26.6-26.6c-9.1-9.1-14.1-21.1-14.1-33.9s5-24.8,14.1-33.9L83.2,11 c3.5-3.5,9.1-3.5,12.6,0c3.5,3.5,3.5,9.1,0,12.6L69.2,50.1c-5.7,5.7-8.9,13.3-8.9,21.3c0,8.1,3.1,15.6,8.9,21.3l26.6,26.6 c3.5,3.5,3.5,9.1,0,12.6C94,133.6,91.8,134.5,89.5,134.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.3,134.5c-4.9,0-8.9-4-8.9-8.9V17.2c0-4.9,4-8.9,8.9-8.9c4.9,0,8.9,4,8.9,8.9v108.4 C28.2,130.5,24.2,134.5,19.3,134.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M135.7,134.5c-2.3,0-4.6-0.9-6.3-2.6c-3.5-3.5-3.5-9.1,0-12.6l26.6-26.6c11.8-11.8,11.8-30.9,0-42.6l-26.6-26.6 c-3.5-3.5-3.5-9.1,0-12.6c3.5-3.5,9.1-3.5,12.6,0l26.6,26.6c18.7,18.7,18.7,49.1,0,67.8L142,131.9 C140.3,133.6,138,134.5,135.7,134.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M111.4,108.8c-2.3,0-4.6-0.9-6.3-2.6c-3.5-3.5-3.5-9.1,0-12.6l21.4-21.4c0.3-0.3,0.3-0.6,0.3-0.8 c0-0.2-0.1-0.6-0.3-0.8l-21.4-21.4c-3.5-3.5-3.5-9.1,0-12.6c3.5-3.5,9.1-3.5,12.6,0L139.1,58c3.6,3.6,5.6,8.3,5.6,13.4 c0,5.1-2,9.8-5.6,13.4l-21.4,21.4C115.9,107.9,113.7,108.8,111.4,108.8z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNegativeIsotype);
export default __webpack_public_path__ + "static/media/negative-isotype.b175c83b6ecc78b0da9adf742dc0f653.svg";
export { ForwardRef as ReactComponent };